//===============================================================================
// タブ切り替え
//===============================================================================
function chgTab(getSelector) {
	var tabBtn = $(getSelector);

	tabBtn.click(function(){

		var tabID = $(this).attr('href');

		$(getSelector).each(function() {
			var hideID = $(this).attr('href');
			$(hideID).addClass('hide');
		});

		$(getSelector).removeClass('current');
		$(this).addClass('current');

		$(tabID).removeClass('hide');

		return false;
	});
}

$(function(){
  $('.searchTab-wrapper a').each(function(){
    var $href = $(this).attr('href');
    if(location.href.match($href)) {
      $(this).addClass('current');
    }
  });

	$(".infoIcon").on({
		"mouseenter":function(){
			$(this).children(".infoIconTxt").addClass("active");
		},
		"mouseleave":function(){
			$(this).children(".infoIconTxt").removeClass("active");
		}
	});

	//スクロールバーの位置を調整
	$('.scrollTable-wrapper').kinetic({
    filterTarget: function(target, e){
        if (!/down|start/.test(e.type)){
            return !(/area|a|input/i.test(target.tagName));
        }
    }
	});
});
